<template lang="html">
  <div class="">
    <Card :show='1'>
      <span slot="show-title">New Role</span>
      <span slot="card-title" class="card-title-spaced">
        New Role
      </span>
      <form class="" @submit.prevent='addRole'>
        <FormField placeholder="Enter name" :value='newRole.name' :onUpdate='e => { newRole.name = e }' labelText='Role Name' />
        <button type="submit" class="btn btn-primary">Create</button>
      </form>
    </Card>
    <div class="" v-if='loaded'>
      <Select v-model='selectedRole' label="name" class='select-role' :options='rolesList' />
      <MoveLists :assigned='assignedPerms' :all='permsList' list-a-title="Assigned Perms" list-b-title="Not Assigned Perms" />
      <button type="button" class="btn btn-primary" @click='save'>Save</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newRole: {
        name: null
      },
      assignedPerms: {
      },
      notAssignedPerms: {
      },
      rolesList: [],
      permsList: [],
      selectedRole: null,
      loaded: false
    }
  },
  watch: {
    selectedRole(val) {
      let roleID = val.id
      this.$http.get(this.resources.Admin.getRolePerms(roleID))
        .then(r => r.json())
        .then(perms => {
          if(!perms) {
            perms = []
          }
          this.assignedPerms = this.nameIDArrayToObject(perms)
          this.notAssignedPerms = this.permsList
        })
    }
  },
  created() {
    let proms = new Array(2)
    proms[0] = this.$store.dispatch('getRolesList')
      .then(roles => {
        this.rolesList = roles
      })

    proms[1] = this.$store.dispatch('getPermsList')
      .then(perms => {
        this.permsList = perms
      })

    Promise.all(proms)
      .then(r => {
        this.loaded = true
      })
  },
  methods: {
    addRole() {
      let form = this.newRole
      this.$http.post(this.resources.Admin.newRole, form)
        .then(r => r.json())
        .then(role => {
          this.notifySuccess(`New role '${form.name}' has been created`)
          this.newRole.name = null
          this.rolesList.push(role)
          this.selectedRole = role
        })
        .catch(err => {
          this.notifyError("Could not insert role.")
        })
    },
    save() {
      let assigned = Object.keys(this.assignedPerms).map(v=>Number(v))
      this.$http.put(this.resources.Admin.editRole(this.selectedRole.id), assigned)
        .then(() => {
          this.notifySuccess(`Role has been edited`)
        })
        .catch(err => {
          this.notifyError("Could not edit role.")
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/EditRoles.admin.vue